import { DictionaryIndicatorAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryIndicators() {
  return useAutocompleteSource<DictionaryIndicatorAutocomplete>({
    url: EvidenceAPI.DICTIONARY_INDICATORS + '/autocomplete',
  });
}
